import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledNoInformationIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 160 160",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M134.4 0H25.6C11.4615 0 0 11.4615 0 25.6V134.4C0 148.538 11.4615 160 25.6 160H134.4C148.538 160 160 148.538 160 134.4V25.6C160 11.4615 148.538 0 134.4 0Z",
			fill: "#F8F6F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.032 111H0.800049",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M159.2 111H28.8",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120 31.2H128",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124 36.8V25.6",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.3999 25.6H47.1999",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.7998 35.2V23.2",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.7998 20V16",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 46.4H29.6",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8 50.4V42.4",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.34 58.3865L135.774 95.947H24.2324L42.667 58.3865H117.34Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.523 78.1053H49.5647V41.8914C49.5647 39.0808 51.8455 36.8 54.656 36.8H106.431C109.242 36.8 111.523 39.0808 111.523 41.8914V78.1053Z",
			fill: "white",
			stroke: "#333333",
			strokeWidth: 2,
			strokeDasharray: "4 4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.2688 69.1259H110.921C113.732 69.1259 116.013 71.4066 116.013 74.2172V101.452H44.1775V74.2172C44.1775 71.4066 46.4583 69.1259 49.2688 69.1259Z",
			fill: "white",
			stroke: "#333333",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.9834 79.9011H117.207C120.018 79.9011 122.298 82.1819 122.298 84.9924V112.227H37.8921V84.9924C37.8921 82.1819 40.1729 79.9011 42.9834 79.9011Z",
			fill: "white",
			stroke: "#333333",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.909 91.5385H103.755C100.944 91.5385 98.6637 93.8192 98.6637 96.6298V100.868H61.3363V96.6298C61.3363 93.8192 59.0556 91.5385 56.245 91.5385H29.0913C26.2808 91.5385 24 93.8192 24 96.6298V133.113C24 135.924 26.2808 138.204 29.0913 138.204H130.909C133.719 138.204 136 135.924 136 133.113V96.6298C136 93.8192 133.719 91.5385 130.909 91.5385Z",
			fill: "white",
			stroke: "#333333",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.1823 122.975C60.2876 122.975 58.7432 121.431 58.7432 119.536C58.7432 117.642 60.2876 116.097 62.1823 116.097H97.8215C99.7161 116.097 101.261 117.642 101.261 119.536C101.261 121.431 99.7161 122.975 97.8215 122.975H62.1823Z",
			fill: "#00AF71"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.821 116.986C99.2308 116.986 100.362 118.126 100.362 119.527C100.362 120.928 99.2218 122.068 97.821 122.068H62.1818C60.772 122.068 59.6406 120.928 59.6406 119.527C59.6406 118.126 60.781 116.986 62.1818 116.986H97.821ZM97.821 115.19H62.1818C59.7843 115.19 57.8447 117.139 57.8447 119.527C57.8447 121.916 59.7933 123.864 62.1818 123.864H97.821C100.218 123.864 102.158 121.916 102.158 119.527C102.158 117.139 100.21 115.19 97.821 115.19Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M87.1778 49.9009L83.604 46.3271L80.542 49.3891L77.48 46.3271L73.9062 49.9009L76.9682 52.9629L73.9062 56.0249L77.48 59.5987L80.542 56.5367L83.604 59.5987L87.1778 56.0249L84.1158 52.9629L87.1778 49.9009Z",
			fill: "#00AF71",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledNoInformationIcon);
const Memo = memo(ForwardRef);
export default Memo;
